import { atom } from 'jotai';

export const isSliderOpen = atom(false);
export const targetItem = atom(0);
export const targetThumnailPage = atom(0);
export const zoomItem = atom(false);

export const setTargetItem = atom(null, (get, set, index) => {
  set(targetItem, index);
});

export const setNextTargetItem = atom(null, (get, set, index) => {
  set(targetItem, (value) => value + 1);
});

export const setPrevTargetItem = atom(null, (get, set, index) => {
  set(targetItem, (value) => value - 1);
});

export const setTargetThumnailPage = atom(null, (get, set, index) => {
  set(targetThumnailPage, index);
});

export const setNextTargetThumnailPage = atom(null, (get, set, index) => {
  set(targetThumnailPage, (value) => value + 3 * 175);
});

export const setPrevTargetThumnailPage = atom(null, (get, set, index) => {
  set(targetThumnailPage, (value) => value - 3 * 175);
});

export const setZoomItem = atom(null, (get, set, index) => {
  set(zoomItem, index);
});
